import { render } from "./PurchaseOrder.vue?vue&type=template&id=4dd356de&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"

import "./PurchaseOrder.vue?vue&type=style&index=0&id=4dd356de&scoped=true&lang=scss"
import "./PurchaseOrder.vue?vue&type=style&index=1&id=4dd356de&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd356de"],['__file',"src/views/PurchaseOrders/PurchaseOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4dd356de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4dd356de', __exports__)) {
    api.reload('4dd356de', __exports__)
  }
  
  module.hot.accept("./PurchaseOrder.vue?vue&type=template&id=4dd356de&scoped=true", () => {
    api.rerender('4dd356de', render)
  })

}


export default __exports__